<app-animated-background class="absolute top-0 h-vh w-dvw"></app-animated-background>
<div class="min-h-screen absolute top-0 w-full flex items-center justify-center p-4 z-[999]">
  <div class="w-full max-w-md login-card">
    @if(!token) {
    <div class="header-section px-8 pt-8 pb-4">
      <div class="lock-icon">
        <mat-icon>lock</mat-icon>
      </div>
      <div class="text-center">
        <h1 class="welcome-title">Forgot Password</h1>
        <p class="welcome-subtitle">Lets send you reset password link!</p>
      </div>
    </div>

    <form [formGroup]="dataForm" (ngSubmit)="sendLink()" class="form-section space-y-2 p-8">
      <div class="form-group">
        <mat-form-field appearance="outline" class="w-full enhanced-field">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" type="email" placeholder="Enter business email">
          <mat-icon matPrefix class="field-icon">email</mat-icon>
          <mat-error *ngIf="dataForm?.get('email')?.hasError('required')">
            <mat-icon class="error-icon">error</mat-icon>
            Email is required
          </mat-error>
          <mat-error *ngIf="dataForm?.get('email')?.hasError('email')">
            <mat-icon class="error-icon">error</mat-icon>
            Please enter a valid email
          </mat-error>
        </mat-form-field>
      </div>


      <button class="submit-button w-full" [disabled]="loading">
        <span class="button-content">
          @if (loading) {
          <mat-spinner diameter="20"></mat-spinner>
          <span>Sending Mail...</span>
          } @else {
          <span>Submit</span>
          }
        </span>
      </button>

      <div class="forgot-password flex items-center justify-center w-full gap-1 text-center">
        <p>Got your password?</p>
        <a routerLink="/login" class="forgot-link">Login</a>
      </div>
    </form>
    } @else {
    <div class="header-section px-8 pt-8 pb-4">
      <div class="lock-icon">
        <mat-icon>lock</mat-icon>
      </div>
      <div class="text-center">
        <h1 class="welcome-title">Reset Password</h1>
        <p class="welcome-subtitle">Enter your new password</p>
      </div>
    </div>

    <form [formGroup]="dataForm" (ngSubmit)="updatePassword()" class="form-section space-y-2 p-8">
      <div class="form-group">
        <mat-form-field appearance="outline" class="w-full enhanced-field">
          <mat-label>Password</mat-label>
          <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password"
            placeholder="Enter your password">
          <mat-icon matPrefix class="field-icon">lock</mat-icon>
          <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" type="button" class="toggle-btn">
            <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-error *ngIf="dataForm?.get('password')?.hasError('required')">
            <mat-icon class="error-icon">error</mat-icon>
            Password is required
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-group">
        <mat-form-field appearance="outline" class="w-full enhanced-field">
          <mat-label>Confirm Password</mat-label>
          <input matInput [type]="hideConfirmPassword ? 'password' : 'text'" formControlName="confirm_password"
            placeholder="Enter your password">
          <mat-icon matPrefix class="field-icon">lock</mat-icon>
          <button mat-icon-button matSuffix (click)="hideConfirmPassword = !hideConfirmPassword" type="button" class="toggle-btn">
            <mat-icon>{{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-error
            *ngIf="dataForm.value.password && (dataForm.value.confirm_password == dataForm.value.password)">
            <mat-icon class="error-icon">error</mat-icon>
            Confirm password is required
          </mat-error>
        </mat-form-field>
      </div>

      <button class="submit-button w-full" [disabled]="loading">
        <span class="button-content">
          @if (loading) {
          <mat-spinner diameter="20"></mat-spinner>
          <span>Updating...</span>
          } @else {
          <span>Update</span>
          }
        </span>
      </button>

    </form>
    }
  </div>
</div>
